import { Text } from 'components/Text';
import { Title } from 'components/Title';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { computePrice } from 'utils/price';
import { PriceBreakdown } from 'services/order/order.type';
import {
    BreakDownRow,
    PriceBreakDownSummaryContainer,
    PriceBreakDownSummaryTitle,
    TotalRow,
} from './PriceBreakDownSummary.style';

export type PriceBreakDownSummaryProps = PriceBreakdown & {
    currency: string;
};

export const PriceBreakDownSummary: React.FunctionComponent<PriceBreakDownSummaryProps> = ({
    totalExclTax,
    totalInclTax,
    totalTax,
    currency,
}) => {
    const { i18n } = useTranslation();
    return (
        <PriceBreakDownSummaryContainer>
            <PriceBreakDownSummaryTitle text={'PriceBreakDownTitle'} weight="bold" />
            <BreakDownRow>
                <Text text={'PriceBreakDownSubtotal'}></Text>
                <Text text={computePrice(i18n, totalExclTax, currency)} noTranslation></Text>
            </BreakDownRow>
            <BreakDownRow>
                <Text text={'PriceBreakDownTaxes'}></Text>
                <Text text={computePrice(i18n, totalTax, currency)} noTranslation></Text>
            </BreakDownRow>
            <TotalRow>
                <Title text={'PriceBreakDownTotal'} type="large" />
                <Title
                    text={computePrice(i18n, totalInclTax, currency)}
                    noTranslation
                    type="large"
                />
            </TotalRow>
        </PriceBreakDownSummaryContainer>
    );
};
